import React from 'react';
import '@mashvisor/design-system/dist/style.css';
import ProductContent from '../components/product/product-content';
import ProductHeader from '../components/product/product-header';
import ProductLayout from '../components/product/product-layout';
import Footer from '../components/footer';
import ProductFooterSearchbar from '../components/product/product-footer-searchbar';
import Users from '../components/product/users';
import SectionNav from '../components/SectionNav';

const buildCanonicalLink = urlSlug => {
  const productSubPath = urlSlug ? `${urlSlug}/` : '';
  return `https://www.mashvisor.com/product/${productSubPath}`;
};
class ProductPage extends React.Component {
  _this = this;
  constructor(props) {
    super(props);
    this.data = props.pageContext.product;

    this.productFeatures = this.data ? this.data.features : [];
    this.canonicalLink = this.data ? buildCanonicalLink(this.data.urlSlug) : '';

    this.contentArray = [];
    this.sectionDescriptions = {
      location: props.location.href,
      fields: [],
    };
    let backgroundColor = 'white';
    let imagePosition = 'left';
    this.pageTitle = this.data ? this.data.title : '';
    this.pageSubTitle = this.data ? this.data.subtitle : '';
    this.metaTitle = this.data ? this.data.metaTitle : '';
    this.metaDescription = this.data ? this.data.metaDescription : '';
    this.metaKeywords = this.data ? this.data.metaKeywords : '';

    this.productFeatures.forEach(feature => {
      this.sectionDescriptions.fields.push({
        description: feature.sectionDescription,
        selector: feature.sectionSelector,
      });
      let newContentItem = {
        imageTitle: feature.image,
        contentTitle: feature.contentTitle,
        contentDescription: feature.contentDescription,
        listItems: feature.listItems,
        ImagePosition: imagePosition,
        backgroundColor: backgroundColor,
        cta: feature.cta,
        altText: feature.altText,
        sectionSelector: feature.sectionSelector,
      };
      this.contentArray.push(newContentItem);
      backgroundColor = backgroundColor === 'white' ? 'grey' : 'white';
      imagePosition = imagePosition === 'left' ? 'right' : 'left';
    });
    this.sectionDescriptions.fields.push({
      description: "Who's Using Mashvisor?",
      selector: 'whos-using-mashvisor',
    });
  }

  render() {
    let _this = this;
    return (
      <ProductLayout
        metaDescription={this.metaDescription}
        metaTitle={this.metaTitle}
        metaKeywords={this.metaKeywords}
        canonicalLink={this.canonicalLink}
      >
        <ProductHeader
          title={this.pageTitle}
          subtitle={this.pageSubTitle}
        ></ProductHeader>
        <SectionNav theme="dark" data={this.sectionDescriptions} />
        {this.contentArray.length
          ? _this.contentArray.map(item => (
              <ProductContent
                sectionSelector={item.sectionSelector}
                pageTitle={this.pageTitle}
                key={`${item.contentTitle}`}
                imageTitle={item.imageTitle}
                contentTitle={item.contentTitle}
                contentDescription={item.contentDescription}
                listItems={item.listItems}
                ImagePosition={item.ImagePosition}
                backgroundColor={item.backgroundColor}
                cta={item.cta}
                altText={item.altText}
              >
                {' '}
              </ProductContent>
            ))
          : ''}
        <Users></Users>
        <ProductFooterSearchbar></ProductFooterSearchbar>
        <Footer></Footer>
      </ProductLayout>
    );
  }
}

export default ProductPage;
